const updateItems = [
  { time: '07.18 03:22', title: '某选秀冠军被曝学历造假，母校声明撇清关系', tag: '最新' },
  { time: '07.18 01:15', title: '短视频平台千万粉丝情侣博主确认分手，互爆黑料', tag: '热' },
  { time: '07.17 22:40', title: '知名影视公司内部邮件泄露，旗下艺人合约条款曝光', tag: '爆' },
  { time: '07.17 18:05', title: '综艺节目录制现场发生冲突，导演与嘉宾当场翻脸', tag: '最新' },
  { time: '07.17 14:30', title: '女演员片场耍大牌被群演集体爆料，连发多条微博控诉', tag: '热' },
  { time: '07.17 09:12', title: '某音乐节主办方跑路，多名艺人演出费被拖欠数月', tag: '最新' },
  { time: '07.16 23:55', title: '顶流艺人代言的保健品被查出含有违禁成分', tag: '爆' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10">
          ⚡ 实时快讯
        </h2>

        <div className="relative">
          <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-[3px] bg-primary-300/60 rounded-full"></div>

          <div className="flex flex-col gap-0">
            {updateItems.map((item, idx) => (
              <div
                key={idx}
                className={`relative flex items-start gap-6 md:gap-8 py-5 pl-10 md:pl-12 ${
                  idx % 2 === 0 ? 'md:ml-0' : 'md:ml-8'
                }`}
              >
                <div className="absolute left-[11px] md:left-[15px] top-[26px] w-[11px] h-[11px] rounded-full bg-primary-500 border-[3px] border-background-50 z-[1]"></div>

                <div className="flex-1 bg-background-100 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-medium text-foreground-500">{item.time}</span>
                    <span
                      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-bold ${
                        item.tag === '爆'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '热'
                          ? 'bg-accent-100 text-accent-700'
                          : 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-900 leading-snug">
                    {item.title}
                  </h3>
                  <div className="mt-3 flex items-center gap-1 text-primary-500 text-sm font-semibold cursor-pointer">
                    查看详情
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}